import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import withConfig from 'with-config';
import ER from 'error-reporting';
import oh from '@allbin/output-helpers';

import default_config from './default_config';
import translations from './translations';
import update_check from './helpers/update_check';

import MainView from './components/views/MainView';


withConfig.setDefault(default_config);
withConfig.get().then((config) => {
    let error_report_config = {
        header: "RT MAP: ",
        slack_webhook: config.slack.webhook_uri,
        disable_slack_posting: (!config.send_errors_to_slack_in_dev && !config.production)
    };

    ER.setConfig(error_report_config);
    update_check.updateCheck(config.update_check_timer);
});

oh.setConfig({
    lang: default_config.default_language
});
oh.addDictionary(translations);

ER.setIntercept((err: any) => {
    console.log("interceptor " + err);
    if (/testerror/.test(err.message) || /fromLatLngToContainerPixel/.test(err.message)) {
        return true;
    }
    return false;
});

declare global {
    interface Window { testerror: any; ER: any; }
}
window.ER = ER;

window.testerror = (msg: string) => {
    throw new Error(msg || "testerror");
};

let MainViewWithER = ER.withErrorReporting(MainView, ER.ErrorAlert, () => {
    let prefix = "User not logged in.";

    let status = ER.getStatus();
    let err = ER.getError();
    let label = oh.translate("sending");
    let body: string[] = [];
    if (err.display_text) {
        body.concat(err.display_text);
    }
    if (status === "sent") {
        label = oh.translate("sent");
        body.concat(oh.translate("error_report_sent"));
    } else if (status === "failed") {
        label = oh.translate("failed");
        body = [
            oh.translate("error_report_failed"),
            oh.translate("please_contact_us")
        ];
    } else {
        body.concat(oh.translate("sending_error_report"));
    }

    return {
        prefix: prefix,
        custom_error_props: {
            title: oh.translate("error_has_occured"),
            label: label,
            body: body,
            action_label: err.action_label || oh.translate("go_to_start"),
            actionCB: () => { err.actionCB ? err.actionCB() : window.location.href = '/'; },
        }
    };
});

MainViewWithER = withConfig(MainViewWithER);

ReactDOM.render(
    <Router>
        <Route path="/">
            <MainViewWithER />
        </Route>
    </Router>,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx